import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import qs from 'qs';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import AccountNavigation from 'components/account/AccountNavigation';
import ResetPassword from 'components/account/ResetPassword';
import AccountLogo from 'components/account/AccountLogo';

import { accountResetPasswordCheck, accountCreatePasswordCheck, accountLogout } from 'redux/modules/account';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

class AccountResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: this.props.appInfo['APP NAME'] === 'security' && !qs.parse(this.props.location.search.slice(1)).check_token
        ? 'No reload email token provided in URL' : null,
    };

    this.onSnackbarClose = this.onSnackbarClose.bind(this);
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
  }

  componentDidMount() {
    const { actions, variant } = this.props;
    const Token = qs.parse(this.props.location.search.slice(1)).check_token;
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
    if (Token) {
      new Promise((resolve, reject) => {
        if (variant === 'create') {
          actions.accountCreatePasswordCheck({
            values: { Token },
            resolve,
            reject,
          });
        } else {
          actions.accountResetPasswordCheck({
            values: { Token },
            resolve,
            reject,
          });
        }
      }).then((res) => {
        if (res && res.url) {
          const redirectOrigin = new URL(res.url).origin;
          if (variant === 'create') {
            window.location.replace(`${redirectOrigin}/new_user_verify_check`);
          } else {
            window.location.replace(`${redirectOrigin}/reload_password_check`);
          }
        }
        return res;
      },
        (err) => {
          this.setState({ error: err.error });
        });
    }
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  onSubmitSuccess() {
    this.setState({ snackbarOpen: true });
  }

  onSnackbarClose() {
    this.setState({ snackbarOpen: false });
  }

  render() {
    const { account, history, actions, variant, appInfo } = this.props;
    const { error } = this.state;
    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} {variant === 'reset' ? 'Password Reset' : 'Password Create'} 
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <ResetPassword
          ID={account.ID}
          error={error}
          form="reset-password"
          variant={variant}
          onSubmitSuccess={() => {
            actions.accountLogout({
              values: {},
              resolve: () => {
                window.location.replace(`${appInfo['LOGIN_REDIRECT_URL']}/account/login`);
              },
              reject: () => {
                window.location.replace(`${appInfo['LOGIN_REDIRECT_URL']}/account/login`);
              },
            });
          }}
        />
        <AccountNavigation />
      </Layout>
    );
  }
}

AccountResetPassword.propTypes = {
  variant: PropTypes.oneOf(['create', 'reset']),
  account: PropTypes.shape({
    ID: PropTypes.number,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    accountResetPasswordCheck: PropTypes.func.isRequired,
    accountCreatePasswordCheck: PropTypes.func.isRequired,
  }).isRequired,
};

AccountResetPassword.defaultProps = {
  variant: 'reset',
};

const mapStateToProps = store => ({
  account: store.account,
  appInfo: store.appInfo,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountResetPasswordCheck, accountCreatePasswordCheck, accountLogout }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountResetPassword);



// WEBPACK FOOTER //
// ./src/pages/account/AccountResetPassword.js